// Product images utility functions
export const productImages = [
  '/images/Achaari Chicken.png',
  '/images/Beef Shawarma.PNG',
  '/images/Chicken Over Rice.JPG', 
  '/images/Chicken Tikka Tacos.PNG',
  '/images/Chicken 65.png',
  '/images/Chicken 65 Burger.png',
  '/images/Chicken Dum Biryani.PNG',
  '/images/Chicken Korma.png',
  '/images/Chicken Shawarma.png',
  '/images/Chicken Sliders.png',
  '/images/Chilli Chicken.png',
  '/images/Double Ka Meetha.png',
  '/images/Double Patty Burger.PNG',
  '/images/Gajar ka Halwa.PNG',
  '/images/Hyderabadi Qubaani Ka Meetha.png',
  '/images/Kaddu Ki Kheer.png',
  '/images/Mutton Dum Biryani.PNG',
  '/images/Mutton Korma.png',
  '/images/Smash Burger.PNG'
];

// Mapping of dish names to their corresponding images
export const dishImageMap: { [key: string]: string } = {
  'Beef Shawarma': '/images/Beef Shawarma.PNG',
  'Chicken Over Rice': '/images/Chicken Over Rice.JPG',
  'Chicken Tikka Tacos': '/images/Chicken Tikka Tacos.PNG',
  'Chicken 65': '/images/Chicken 65.png',
  'Double Patty Burger': '/images/Double Patty Burger.PNG',
  'Gajar Ka Halwa': '/images/Gajar ka Halwa.PNG',
  'Hyderabadi Mutton Dum Biryani': '/images/Mutton Dum Biryani.PNG',
  'Hyderabadi Chicken Dum Biryani': '/images/Chicken Dum Biryani.PNG',
  'Hyderabadi Chicken Korma': '/images/Chicken Korma.png',
  'Hyderabadi Mutton Korma': '/images/Mutton Korma.png',
  'Hyderabadi Chicken 65 Burger': '/images/Chicken 65 Burger.png',
  'Hyderabadi Chilli Chicken': '/images/Chilli Chicken.png',
  'Hyderabadi Achaari Chicken': '/images/Achaari Chicken.png',
  'Hyderabadi Chicken Shawarma': '/images/Chicken Shawarma.png',
  'Hyderabadi Chicken Sliders': '/images/Chicken Sliders.png',
  'Hyderabadi Kaddu ki Kheer': '/images/Kaddu Ki Kheer.png',
  'Hyderabadi Double ka Meetha': '/images/Double Ka Meetha.png',
  'Hyderabadi Qubani ka Meetha': '/images/Hyderabadi Qubaani Ka Meetha.png',
  'Smash Burger': '/images/Smash Burger.PNG'
};

// Get a random product image
export const getRandomProductImage = (): string => {
  const randomIndex = Math.floor(Math.random() * productImages.length);
  return productImages[randomIndex];
};

// Get a specific product image by index (for consistent display)
export const getProductImage = (index: number): string => {
  return productImages[index % productImages.length];
};

// Get image for a specific dish name
export const getImageForDish = (dishName: string): string => {
  return dishImageMap[dishName] || getRandomProductImage();
};

// Get all product images
export const getAllProductImages = (): string[] => {
  return [...productImages];
};

// Get product image by name (partial match)
export const getProductImageByName = (name: string): string | null => {
  const lowerName = name.toLowerCase();
  const matchedImage = productImages.find(img => 
    img.toLowerCase().includes(lowerName) || lowerName.includes(img.toLowerCase().split('/').pop()?.split('.')[0] || '')
  );
  return matchedImage || null;
};
